export const LANDLINE_TWITTER = "https://twitter.com/ridelandline"
export const LANDLINE_FACEBOOK = "https://www.facebook.com/ridelandline"
export const LANDLINE_INSTAGRAM = "https://www.instagram.com/ridelandline"
